'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FaPagelines = function FaPagelines(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35.8 24.6q-0.7 1.8-1.7 3.1t-2 2-2.2 1-2.3 0.3-2.2-0.2-1.9-0.4-1.5-0.7-1.1-0.5l-0.4-0.2q-2.5 5.1-6.4 8t-8.6 3q-0.4 0-0.7-0.3t-0.3-0.7 0.3-0.7 0.7-0.3q3.9 0 7.2-2.4t5.6-6.6q-0.8 0.4-1.6 0.6t-1.8 0.2-2.1 0-2-0.6-2.1-1.4-1.9-2.2-1.6-3.3q2.5-1 4.7-1.2t3.8 0.1 2.7 1.3 2 1.7 1.3 1.9q1.2-3 1.7-6.5-0.1 0-0.4 0t-1 0.1-1.5 0-1.9-0.3-1.9-0.5-1.9-0.9-1.7-1.5-1.2-2.1-0.6-2.8q1.5-0.7 2.9-0.9t2.5 0.1 2.1 0.6 1.6 1.2 1.3 1.3 0.9 1.4 0.6 1.3 0.4 0.9l0.1 0.3q0.3-2.7 0.3-4.3-0.2-0.2-0.5-0.4t-1.1-1-1.4-1.6-1.2-2.1-0.8-2.5 0.3-2.8 1.6-3.1q1.6 0.6 2.8 1.4t1.9 1.7 1.1 1.9 0.4 2 0 1.9-0.3 1.7-0.4 1.4-0.4 0.9l-0.1 0.3q0 0.2 0 1.2t0 1.6q0-0.2 0.2-0.4t0.7-1 1.1-1.3 1.6-1.2 2-1 2.5-0.4 3 0.6q-0.1 1.7-0.5 3.1t-1.1 2.4-1.6 1.6-1.8 1-1.9 0.5-1.8 0.2-1.5 0-1-0.1l-0.4-0.1q-0.5 3.3-1.6 6.4 0.1-0.2 0.4-0.5t1.1-0.9 1.7-1.1 2.2-1 2.7-0.4 2.8 0.5 3.1 1.7z' })
        )
    );
};

exports.default = FaPagelines;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/fa/pagelines.js
// module id = 926
// module chunks = 168707334958949